/**
 * Task WA-center: WhatsApp 中心 (sidebar → WhatsApp) — connection, confirmation / reminder texts, synced contacts,
 * broadcasts (群发) and activity. One row per key: [key, English, 中文]; Malay falls back to English.
 */
const ROWS = [
  ["wac.nav","WhatsApp","WhatsApp"],
  ["wac.title","WhatsApp","WhatsApp"],
  ["wac.sub","Each branch's own WhatsApp number: link it, edit the booking texts, sync contacts and send broadcasts.","每个分店自己的 WhatsApp 号码：连接、编辑预约消息、同步联系人和群发。"],
  ["wac.refresh","Refresh","刷新"],
  ["wac.tab.connect","Connect","连接"],
  ["wac.tab.confirm","Confirmation text","预约确认模板"],
  ["wac.tab.reminder","Reminder text","预约提醒模板"],
  ["wac.tab.contacts","Contacts","联系人"],
  ["wac.tab.broadcast","Broadcast","群发"],
  ["wac.tab.activity","Activity","动态"],
  ["wac.head.contacts","Contacts {n}","联系人 {n}"],
  ["wac.head.synced","Synced {date}","同步 {date}"],
  ["wac.head.never","Not synced yet","尚未同步"],
  ["wac.off","WhatsApp via a linked phone is switched off on this platform.","平台已关闭 WhatsApp 关联设备功能。"],
  ["wac.needConnect","Connect this branch's WhatsApp first (tab Connect).","请先连接本分店的 WhatsApp（「连接」页）。"],
  // (WA-branch) one number per branch
  ["wac.br.label","Branch","分店"],
  ["wac.br.all","All branches","全部分店"],
  ["wac.br.none","No branch to show.","没有可显示的分店。"],
  ["wac.br.intro","Each branch links its own WhatsApp number. Booking confirmations and reminders go out from the number of the booking's branch; a branch without a linked number uses e-mail instead (never another branch's number).","每个分店连接自己的 WhatsApp 号码。预约确认和提醒从该预约所属分店的号码发出；未连接的分店改用邮件（不会用其他分店的号码）。"],
  ["wac.br.today","Today: {sent} sent · {failed} failed","今日：已发 {sent} · 失败 {failed}"],
  ["wac.br.todayCap","Today: {sent} sent · {failed} failed · limit {cap}","今日：已发 {sent} · 失败 {failed} · 上限 {cap}"],
  ["wac.br.queued","{n} waiting","等待 {n}"],
  ["wac.br.open","Open","打开"],
  ["wac.tpl.shared","One text for all branches.","所有分店共用同一份内容。"],
  ["wac.bc.from","Sent from: {from} — to this branch's WhatsApp contacts.","发送号码：{from} —— 发给本分店 WhatsApp 的联系人。"],
  ["wac.goConnect","Go to Connect","去连接"],
  ["wac.movedFrom","These settings used to be under Settings → Customer messages.","这些设置原在 设置 → 顾客消息。"],
  ["wac.moved","WhatsApp settings moved to the sidebar: WhatsApp","WhatsApp 设置已移至左侧「WhatsApp」"],
  ["wac.movedOpen","Open WhatsApp","打开 WhatsApp"],
  // templates
  ["wac.tpl.introConfirm","Sent from your linked WhatsApp right after a booking is made (POS or online).","预约创建后立即从已连接的 WhatsApp 发送（收银台或在线预约）。"],
  ["wac.tpl.introReminder","Sent from your linked WhatsApp before the appointment, at the lead times below.","在预约前按下面设置的时间，从已连接的 WhatsApp 发送。"],
  ["wac.tpl.lang","Language","语言"],
  ["wac.tpl.langHint","Customers get the text in their own language (English if not set).","顾客收到自己语言的版本（未设置则为英文）。"],
  ["wac.tpl.text","Message text","消息内容"],
  ["wac.tpl.chips","Tap to insert","点击插入"],
  ["wac.tpl.ph.customer","Customer","顾客"],
  ["wac.tpl.ph.service","Service","服务"],
  ["wac.tpl.ph.date","Date","日期"],
  ["wac.tpl.ph.time","Time","时间"],
  ["wac.tpl.ph.staff","Staff","服务人员"],
  ["wac.tpl.ph.shop","Shop","店名"],
  ["wac.tpl.ph.address","Address","地址"],
  ["wac.tpl.ph.link","Manage link","管理链接"],
  ["wac.tpl.preview","Preview (example customer)","预览（示例顾客）"],
  ["wac.tpl.previewNote","A greeting / sign-off varies slightly per message so it reads naturally; staff and address are added when the text doesn't include them.","每条消息的问候语和结尾会略有不同，读起来更自然；文本中没有服务人员和地址时会自动附上。"],
  ["wac.tpl.save","Save","保存"],
  ["wac.tpl.saved","Saved","已保存"],
  ["wac.tpl.reset","Restore default","恢复默认"],
  ["wac.tpl.resetDone","Back to the default text","已恢复默认文本"],
  ["wac.tpl.custom","Your own text","自定义文本"],
  ["wac.tpl.default","Default (same as the e-mail text)","默认（与邮件文本相同）"],
  ["wac.tpl.test","Send test to my WhatsApp","发送测试到我的 WhatsApp"],
  ["wac.tpl.testSent","Test queued to {phone} (your own chat). It usually arrives within a minute (inside your sending hours, if you set any).","测试已排队发送到 {phone}（您自己的对话）。通常一分钟内送达（如设置了发送时段，则在时段内）。"],
  ["wac.tpl.unknown","Unknown placeholder: {ph}","未知占位符：{ph}"],
  ["wac.tpl.hours","Reminder (hours before)","提醒（提前小时数）"],
  ["wac.tpl.hoursHint","Comma-separated, e.g. 24, 2 — the same setting as Settings → Customer messages → Reminders & rules.","用逗号分隔，例如 24, 2 —— 与 设置 → 顾客消息 → 提醒与规则 是同一个设置。"],
  ["wac.tpl.hoursSaved","Reminder times saved","提醒时间已保存"],
  // contacts
  ["wac.ct.intro","All WhatsApp contacts of the linked number (names and numbers only — chats are never read or stored).","已连接号码的全部 WhatsApp 联系人（只有名字和号码，不读取也不保存聊天内容）。"],
  ["wac.ct.count","{n} contacts · {m} are customers","{n} 个联系人 · {m} 个是顾客"],
  ["wac.ct.sync","Refresh sync","刷新同步"],
  ["wac.ct.syncAsked","Sync requested — new contacts appear in a minute or two.","已请求同步，一两分钟内显示新联系人。"],
  ["wac.ct.search","Search name or number","搜索名字或号码"],
  ["wac.ct.f.all","All contacts","全部联系人"],
  ["wac.ct.f.customers","Customers only","仅顾客"],
  ["wac.ct.f.others","Not customers","非顾客"],
  ["wac.ct.customer","Customer","顾客"],
  ["wac.ct.optedOut","Opted out","已退订"],
  ["wac.ct.empty","No contacts yet. Connect WhatsApp — contacts sync automatically after linking.","还没有联系人。连接 WhatsApp 后会自动同步联系人。"],
  ["wac.ct.noName","(no name)","（无名字）"],
  ["wac.ct.more","Showing the first {n}. Search to find others.","仅显示前 {n} 个，请搜索查找其他联系人。"],
  // broadcast
  ["wac.bc.step1","1. Write message","1. 编写消息"],
  ["wac.bc.step2","2. Choose contacts","2. 选择联系人"],
  ["wac.bc.placeholder","Message to send (WhatsApp formatting: *bold* _italic_). {name} = the contact's name.","输入要群发的内容（支持 WhatsApp 格式：*粗体* _斜体_）。{name} = 联系人名字。"],
  ["wac.bc.insertName","Insert {name}","插入 {name}"],
  ["wac.bc.image","Add a picture","加一张图片"],
  ["wac.bc.imageRemove","Remove picture","移除图片"],
  ["wac.bc.imageHint","One JPG / PNG picture, sent with the text as caption (max 800 KB; large photos are shrunk).","一张 JPG / PNG 图片，文字作为图片说明一起发送（最大 800 KB，大图会自动缩小）。"],
  ["wac.bc.imageBad","This picture can't be used (JPG / PNG / WebP, max 800 KB).","无法使用这张图片（JPG / PNG / WebP，最大 800 KB）。"],
  ["wac.bc.saveTpl","Save as template","保存为模板"],
  ["wac.bc.tplName","Template name","模板名称"],
  ["wac.bc.tplSaved","Template saved","模板已保存"],
  ["wac.bc.pickTpl","Use a saved template…","使用已保存的模板…"],
  ["wac.bc.delTpl","Delete template","删除模板"],
  ["wac.bc.gap","Random gap between each contact","每个联系人之间随机间隔"],
  ["wac.bc.gapUnit","seconds (min 20)","秒（最少 20 秒）"],
  ["wac.bc.risk","Sending many similar messages quickly from a personal number can get it restricted by WhatsApp. Longer gaps and sending only to people who know your shop lower the risk.","个人号码短时间发送大量相似消息，可能被 WhatsApp 限制。间隔长一些、只发给认识您店铺的人，风险更低。"],
  ["wac.bc.rules","Messages go out one by one, {gap} apart, {hours}. No daily limit.","消息逐条发送，每条间隔 {gap}，{hours}发送，不限每日数量。"],
  ["wac.bc.rulesCap","Messages go out one by one, {gap} apart, {hours}. At most {cap} WhatsApp messages a day per branch (booking confirmations and reminders included); the rest continues the next day.","消息逐条发送，每条间隔 {gap}，{hours}发送。每个分店每天最多 {cap} 条 WhatsApp 消息（含预约确认和提醒），超出部分次日继续。"],
  ["wac.bc.aud.all","All synced contacts","全部已同步联系人"],
  ["wac.bc.aud.customers","Only customers","仅顾客"],
  ["wac.bc.excludeOptOut","Exclude customers who opted out","排除已退订的顾客"],
  ["wac.bc.selectAll","Select all","全选"],
  ["wac.bc.selectNone","Select none","全不选"],
  ["wac.bc.selected","{n} selected","已选 {n} 人"],
  ["wac.bc.review","Preview & send","预览并发送"],
  ["wac.bc.confirmTitle","Send this broadcast?","确认群发？"],
  ["wac.bc.confirmBody","Will send to {n} people, about {dur} in total ({n} × {avg} s on average).","将发送给 {n} 人，预计共约 {dur}（{n} × 平均 {avg} 秒）。"],
  ["wac.bc.pauseNote","Sending pauses outside {from}–{to} (shop time) and continues at {from}.","店铺时间 {from}–{to} 以外暂停发送，{from} 继续。"],
  ["wac.bc.endsAt","Last message about: {date}","最后一条约：{date}"],
  ["wac.dur.sec","{n} seconds","{n} 秒"],
  ["wac.dur.min","{n} minutes","{n} 分钟"],
  ["wac.dur.hm","{h} h {m} min","{h} 小时 {m} 分钟"],
  ["wac.gap.fixed","{a} s","{a} 秒"],
  ["wac.gap.range","{a}–{b} s","{a}–{b} 秒"],
  ["wac.hours.any","any time of day","任何时间"],
  ["wac.hours.win","only {from}–{to}","仅 {from}–{to} "],
  // (2026-11-04) the shop's own sending rules
  ["wac.sr.title","Sending rules (all branches)","发送规则（所有分店）"],
  ["wac.sr.intro","For booking confirmations, reminders and broadcasts from every branch's linked number.","适用于各分店绑定号码发送的预约确认、提醒和群发。"],
  ["wac.sr.gap","Gap between two messages","每条消息间隔"],
  ["wac.sr.gapUnit","seconds (1–600)","秒（1–600）"],
  ["wac.sr.windowOn","Only send during these hours","只在这段时间发送"],
  ["wac.sr.from","From","从"],
  ["wac.sr.to","To","到"],
  ["wac.sr.any","Off: messages go out any time, day and night.","未开启：任何时间都会发送（包括夜间）。"],
  ["wac.sr.hoursHint","Outside these hours messages wait and go out at the start time (each branch's time zone).","此时段以外的消息会等待，到开始时间再发送（按各分店时区）。"],
  ["wac.sr.risk","Very short gaps make it more likely that WhatsApp restricts a personal number.","间隔很短时，个人号码被 WhatsApp 限制的可能性更高。"],
  ["wac.sr.noCap","No daily limit.","不限每日数量。"],
  ["wac.sr.cap","Platform daily limit: {cap} messages per branch.","平台每日上限：每个分店 {cap} 条。"],
  ["wac.sr.save","Save rules","保存规则"],
  ["wac.sr.saved","Sending rules saved","发送规则已保存"],
  ["wac.sr.ownerOnly","Only the owner can change these rules.","只有店主可以修改发送规则。"],
  ["wac.sr.summary","{gap} apart · {hours}","间隔 {gap} · {hours}"],
  ["wac.bc.confirmDays","Over the daily limit ({cap}): it is spread over {d} days —","超过每日上限（{cap} 条）：将分 {d} 天发送 ——"],
  ["wac.bc.dayLine","{date}: {n}","{date}：{n} 条"],
  ["wac.bc.startsAt","First message: {date}","第一条发送时间：{date}"],
  ["wac.bc.send","Send","确认发送"],
  ["wac.bc.started","Broadcast started — follow it under Activity.","群发已开始，可在「动态」查看进度。"],
  ["wac.bc.needText","Write the message first.","请先输入消息内容。"],
  ["wac.bc.needContacts","Choose at least one contact.","请至少选择一个联系人。"],
  // activity
  ["wac.ac.broadcasts","Broadcasts","群发任务"],
  ["wac.ac.noBroadcasts","No broadcasts yet.","还没有群发。"],
  ["wac.ac.progress","Sent {sent} · Failed {failed} · Waiting {pending} / {total}","已发 {sent} · 失败 {failed} · 待发 {pending} / {total}"],
  ["wac.ac.next","Next: {date}","下一条：{date}"],
  ["wac.ac.pause","Pause","暂停"],
  ["wac.ac.resume","Resume","继续"],
  ["wac.ac.cancel","Cancel","取消"],
  ["wac.ac.cancelConfirm","Cancel this broadcast? Messages not sent yet won't be sent.","取消这个群发？尚未发送的消息将不再发送。"],
  ["wac.ac.st.running","Sending","发送中"],
  ["wac.ac.st.paused","Paused","已暂停"],
  ["wac.ac.st.canceled","Cancelled","已取消"],
  ["wac.ac.st.done","Finished","已完成"],
  ["wac.ac.log","Message log","发送记录"],
  ["wac.ac.t.all","All types","全部类型"],
  ["wac.ac.t.confirm","Confirmation","确认"],
  ["wac.ac.t.reminder","Reminder","提醒"],
  ["wac.ac.t.broadcast","Broadcast","群发"],
  ["wac.ac.t.test","Test","测试"],
  ["wac.ac.s.all","All statuses","全部状态"],
  ["wac.ac.s.sent","Sent","已发送"],
  ["wac.ac.s.pending","Waiting","等待中"],
  ["wac.ac.s.failed","Failed","失败"],
  ["wac.ac.s.skipped","Not sent","未发送"],
  ["wac.ac.empty","No WhatsApp messages yet.","还没有 WhatsApp 消息。"],
  ["wac.ac.full","All customer messages (incl. e-mail)","全部顾客消息（含邮件）"],
  ["wac.ac.err.canceled","cancelled","已取消"],
  ["wac.ac.err.no_whatsapp","number has no WhatsApp","该号码没有 WhatsApp"],
  ["wac.ac.err.daily_cap","daily limit reached","已达每日上限"],
  // (Task WA-app) read-only WhatsApp view in the store app (更多 → WhatsApp)
  ["wap.nav","WhatsApp","WhatsApp"],
  ["wap.sub","Each branch's WhatsApp number at a glance (view only).","各分店 WhatsApp 号码概况（只读）。"],
  ["wap.st.connected","Connected {phone}","已连接 {phone}"],
  ["wap.st.lost","Disconnected","已断开"],
  ["wap.st.linking","Linking…","绑定中"],
  ["wap.st.none","Not linked","未连接"],
  ["wap.lostWarn","This number was disconnected ({phone}). Booking messages go by e-mail until it is linked again on the web.","此号码已断开（{phone}）。重新绑定前，预约消息改用邮件发送。"],
  ["wap.sync","Last sync {date}","上次同步 {date}"],
  ["wap.neverSync","Contacts not synced yet","联系人尚未同步"],
  ["wap.contacts","{n} contacts · {m} are customers","联系人 {n} · 其中顾客 {m}"],
  ["wap.today","Today","今日"],
  ["wap.k.confirm","Confirmations","确认"],
  ["wap.k.reminder","Reminders","提醒"],
  ["wap.k.broadcast","Broadcasts","群发"],
  ["wap.k.failed","Failed","失败"],
  ["wap.k.left","Left today","今日剩余"],
  ["wap.k.queued","Waiting","等待中"],
  ["wap.rules","Sending: {rules}","发送：{rules}"],
  ["wap.capOf","of {cap}","/ {cap}"],
  ["wap.queued","{n} waiting to send","等待发送 {n}"],
  ["wap.bc.title","Running broadcasts","进行中的群发"],
  ["wap.bc.progress","{sent}/{total} sent · {failed} failed · {pending} left","已发 {sent}/{total} · 失败 {failed} · 剩余 {pending}"],
  ["wap.bc.running","Sending","发送中"],
  ["wap.bc.paused","Paused","已暂停"],
  ["wap.bc.next","next {time}","下一条 {time}"],
  ["wap.log","Send log","发送记录"],
  ["wap.log.empty","No messages yet.","暂无发送记录。"],
  ["wap.log.page","Page {p} of {n}","第 {p}/{n} 页"],
  ["wap.log.prev","Previous","上一页"],
  ["wap.log.next","Next","下一页"],
  ["wap.t.other","Other","其他"],
  ["wap.open","Details","查看详情"],
  ["wap.webOnly","Linking, editing texts and broadcasts: please use the web version.","绑定、改模板、群发请在网页版操作"],
  ["wap.denied","Only the owner and managers can see this page.","仅店主和店长可查看此页面。"],
  ["wap.worker","The WhatsApp sender is offline right now — messages wait until it is back.","WhatsApp 发送服务暂时离线，消息会排队等待。"],
] as const;

export type WacKey = (typeof ROWS)[number][0];
const col = (i: 1 | 2) => Object.fromEntries(ROWS.map((r) => [r[0], r[i]])) as Record<WacKey, string>;

export const taskWAC = { en: col(1), zh: col(2), ms: col(1) };
